import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";

// Fetches an endpoint scoped to the active site; refetches on site change.
export function useModuleData(path, deps = []) {
  const { activeSite } = useSite();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const sep = path.includes("?") ? "&" : "?";
      const { data } = await api.get(`${path}${sep}site=${activeSite}`);
      setData(data);
    } catch (e) {
      setData(null);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, activeSite]);

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [load, ...deps]);

  return { data, loading, reload: load };
}
